import axios from 'axios';
import { getToken } from '@/utils/auth'


// export const baseURL = "http://lims.tjthzc.com/lims-web"
//export const baseURL = "http://purchase.tjthzc.com/purchase-manage"

export const baseURL = process.env.BASE_URL


const service = axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    // easy-mock服务挂了，暂时不使用了
    // baseURL: 'https://www.easy-mock.com/mock/592501a391470c0ac1fab128',

    baseURL: process.env.BASE_URL, // TODO 不知道怎么接上，请接上，谢谢
    //baseURL: 'http://purchase.tjthzc.com/purchase-manage', // TODO 不知道怎么接上，请接上，谢谢
    timeout: 5000
});


service.interceptors.request.use(
    config => {
        let token = getToken();
        let shopId = '1001'
        if (token) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers['X-Token'] = token
        }
      if (shopId) {
        // let each request carry token
        // ['X-Token'] is a custom headers key
        // please modify it according to the actual situation
        config.headers['shopId'] = localStorage.getItem("shopId");
      }
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            let code = response.data.code;
            if(code == '1001'){
                //退出登陆
                this.$store.dispatch('user/logout')
            }
            return response.data;
        } else {
            Promise.reject();
        }
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js